import * as yup from "yup";
import BaseForm from "../../../../../../shared/components/form/BaseForm";
import { useTranslation } from "react-i18next";
import FormDatePicker from "../../../../../../shared/components/datepicker/FormDatePicker";
import FormInput from "../../../../../../shared/components/input/FormInput";
import FormSelect from "../../../../../../shared/components/select/FormSelect";
import FileInput from "../../../../../../shared/components/file-input/FileInput";

const BulkLoadObjectiveTrackerForm = ({ onSubmitHandler, clients }) => {
  const { t } = useTranslation();

  const validationSchema = yup.object({
    beginDate: yup
      .date()
      .required(t("objectivesTracker.createForm.fields.beginDate.required")),
    endDate: yup
      .date()
      .required(t("objectivesTracker.createForm.fields.endDate.required")),
    clientId: yup
      .string()
      .required(t("objectivesTracker.createForm.fields.client.required")),
    name: yup
      .string()
      .required(t("objectivesTracker.createForm.fields.name.required")),
    file: yup.mixed().required("El fichero CSV a cargar es obligatorio"),
  });

  const defaultValues = {
    beginDate: "",
    endDate: "",
    clientId: "",
    name: "",
    goal: 0,
    threshold: 0,
    file: null,
  };

  return (
    <BaseForm
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      onSubmitHandler={onSubmitHandler}
    >
      <div className="flex flex-row justify-between gap-x-4">
        <div className="w-1/2">
          <FormDatePicker
            name="beginDate"
            label={t("objectivesTracker.createForm.fields.beginDate.label")}
            required
          />
        </div>
        <div className="w-1/2">
          <FormDatePicker
            name="endDate"
            label={t("objectivesTracker.createForm.fields.endDate.label")}
            required
          />
        </div>
      </div>
      <FormInput
        name="name"
        label={t("objectivesTracker.createForm.fields.name.label")}
        placeholder={t("objectivesTracker.createForm.fields.name.placeholder")}
        required
      />
      <div className="flex flex-row justify-between gap-x-4">
        <div className="w-1/2">
          <FormSelect
            name="clientId"
            label={t("objectivesTracker.createForm.fields.client.label")}
            options={clients}
            required
          />
        </div>
        <div className="w-1/2">
          <FormInput
            type="number"
            name="goal"
            label={t("objectivesTracker.createForm.fields.goal.label")}
          />
        </div>
      </div>
      <FileInput
        name="file"
        label="File to upload"
        placeholder="CSV to load and create a new objective tracker"
        required
      />
    </BaseForm>
  );
};

export default BulkLoadObjectiveTrackerForm;
